import React, { useState, useEffect } from 'react';
import { dateToLocal } from '../shared/Functions';
import { ImagesVService } from '../../services/V2/aurascope';
import { authProvider } from '../../services/Security';
import { CustomTable } from '../shared/CustomTable';

export const MeterImages = (props) => {
    const [filters, setFilters] = useState<any[]>([]);
    const [token, setToken] = useState<any>();
    const [loading, setLoading] = useState<boolean>(true);
    const [formData, setFormData] = useState<any>({
        fromCreatedAt: "",
        toCreatedAt: "",
    });

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if (!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setFormData(data)
        setToken(data?.token)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });

    useEffect(() => {
        let filterArray: any[] = [];
        if (formData.districtId) filterArray.push({ property: "MeterRoute.DistrictId", value: formData.districtId })
        if (formData.routeId) filterArray.push({ property: "MeterRouteId", value: formData.routeId })
        if (formData.meterId) filterArray.push({ property: "MeterId", value: formData.meterId })
        if (formData.userId) filterArray.push({ property: "UserId", value: formData.userId })
        if (formData.createdById) filterArray.push({ property: "CreatedBy", value: formData.createdById })
        setFilters(filterArray)
        setLoading(true)
    }, [formData])// eslint-disable-line react-hooks/exhaustive-deps

    return (
        <React.Fragment>
            <CustomTable
                title=""
                columns={[
                    { title: 'Id', field: 'id', editable: 'never' },
                    { title: 'Image', field: 'preSignedUrl', editable: 'never', render: rowData => <img alt="error" style={{ maxHeight: "70px" }} src={rowData.preSignedUrl} /> },
                    { title: 'Route Id', field: 'meterRouteId', editable: 'never' },
                    { title: 'Route Name', field: 'meterRouteName', editable: 'never', sorting: false },
                    { title: 'Meter Id', field: 'meterId', editable: 'never' },
                    { title: 'Meter Number', field: 'meterNumber', editable: 'never', sorting: false },
                    { title: 'User Id', field: 'userId', editable: 'never' },
                    { title: 'User Name', field: 'userName', editable: 'never', sorting: false },
                    { title: 'Created At', field: 'createdAt', editable: 'never', render: rowData => dateToLocal(rowData.createdAt).toLocaleString() },
                    { title: 'Created By', field: 'created', editable: 'never' }
                ]}
                dataEndpoint={query => {
                    return new Promise((resolve, reject) => {
                        if (!token || !formData?.districtId) {
                            resolve({
                                data: [],
                                page: query.page,
                                totalCount: 0
                            });
                        } else {
                            ImagesVService.imagesVGetAll({
                                pageNumber: query.page + 1,
                                numberPerPage: query.pageSize,
                                orderBy: query?.orderBy?.field?.toString() ?? "Id",
                                orderByDesc: query.orderDirection === "desc",
                                filters: filters,
                                fromDate: formData.fromCreatedAt || null,
                                toDate: formData.toCreatedAt || null
                            }).then((x: any) => {
                                resolve({
                                    data: x.items ?? [],
                                    page: query.page,
                                    totalCount: x.numberOfItems ?? 0
                                });
                            }).catch(x => {
                                reject(x);
                            });
                        }
                    });
                }}
                actions={[]}
                refresh={loading} setRefresh={setLoading} pageSize={15} enablePaging={true}
                districtId={null} addedQuery={null} hiddenColumns={[]} setHiddenColumns={() => { }} hiddenColumnsDisabled={true}
                tableHeight={"400px"} enableSearch={false} searchPlaceholder={null} dataSet={null}
            />
        </React.Fragment>
    );
}